export default __webpack_public_path__ + "76a4fbe.png";